import { render } from "./TheIntroVideo.vue?vue&type=template&id=ecda2a60"
import script from "./TheIntroVideo.vue?vue&type=script&lang=js"
export * from "./TheIntroVideo.vue?vue&type=script&lang=js"

import "./TheIntroVideo.vue?vue&type=style&index=0&id=ecda2a60&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__